import { render } from "./AdminImageUpload.vue?vue&type=template&id=06a464c6&ts=true&lang=true"
import script from "./AdminImageUpload.vue?vue&type=script&lang=ts"
export * from "./AdminImageUpload.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__